<template>
  <div class="page-mentor">
    <div class="g-wrap">
      <!-- <div class="chat-content"> -->
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/ss`"
          >社会服务</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="`${$subsitePrefix}/ss/expert`"
          >专家</el-breadcrumb-item
        >
        <el-breadcrumb-item>在线咨询</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content mentor-content">
        <Chat></Chat>
      </div>
    </div>
  </div>
</template>

<script>
import Chat from "@/components/Chat";
export default {
  components: {
    Chat
  },
  data() {
    return {
      goUrl: ""
    };
  },
  mounted() {
    this.goUrl = `http://recruit.ve-city.com/chat`;
  }
};
</script>

<style lang="scss" scoped>
.page-mentor {
  background: #f6f6f9;
  padding-bottom: 40px;
  display: flex;
  justify-content: center;

  .mentor-content {
    width: 100%;
    padding: 0;
    position: relative;
    overflow: auto;
  }
}
</style>
